<template>
    <div v-if="isShowDepartments" class="">
        <div id="ai-app-depart-list-text">Подразделение</div>
        <local-tree-view
            id="ai-ai-app-depart-tree"
            ref="treeViewRef"
            :data-source="departmentList"
            :meta="meta"
            @item-click="onItemClick"
            @empty-filter-result="emptyFilterResult"
            @filter-result="filterResult"
            class="ai-department-tree-view"
        >
            <template #item="{ data }">
                <div class="ai-app-depart-tree-item">
                    <component :is="data?.svg" class="ai-app-depart-tree-item-svg" />
                    <div class="ai-app-depart-tree-item-text">{{ data.name }}</div>
                </div>
            </template>
        </local-tree-view>
    </div>
</template>

<script>
export default {
    name: 'department-list',
};
</script>

<script setup>
import { inject, ref, onMounted, nextTick, defineEmits } from 'vue';
import localTreeView from '@/components/local-tree-view.vue';
import { getCookie, setCookie } from '@/utils/cookies';
import { getUserDeparts } from '@/store/global';

const treeViewRef = ref(null);
const treeViewInstance = ref();
const departmentList = ref([]);
const formData = inject('formData');
const isShowDepartments = inject('isShowDepartments');
const selectedDeps = ref(new Map());
const data = ref();
const emit = defineEmits(['emptyFilterResult', 'setDepart']);
onMounted(async () => {
    treeViewInstance.value = treeViewRef.value?.treeViewInstance;
    data.value = treeViewRef.value?.ds;

    treeViewRef.value.treeViewInstance.on('optionChanged', () => {
        data.value = treeViewRef.value?.ds;
    });

    const selectedDepFromCookie = getCookie('selectedDep');
    const currentLogin = getCookie('login');

    setTimeout(() => {
        treeViewInstance.value.expandAll();
    }, 400);
    const userDeparts = await getUserDeparts();
    departmentList.value = userDeparts.items;

    let grandParents = new Map();
    let parents = new Map();
    let childs = new Map();

    departmentList.value.forEach(item => {
        if (item.parent_id === null)
        grandParents.set(item.dep_id, item);
        item.svg = 'ai-dep-energo-system-svg';
    });

    departmentList.value.forEach(item => {
        if (item.parent_id !== null && grandParents.get(item.parent_id)) {
            parents.set(item.dep_id, item);
            item.svg = 'ai-dep-tat-energo-svg';
        }
    });

    departmentList.value.forEach(item => {
        if (item.parent_id !== null && parents.get(item.parent_id)) {
            childs.set(item.dep_id, item);
            item.svg = 'ai-filial-svg';
        }
    });

    if (selectedDepFromCookie) {
        try {
            const selectedDepArray = JSON.parse(selectedDepFromCookie);
            selectedDeps.value = new Map(selectedDepArray);
            if (selectedDeps.value) {
                await nextTick();
                formData.depId = selectedDeps.value.get(currentLogin);
                treeViewInstance.value.selectItem(formData.depId);
            }
        } catch (error) {
            console.log(error);
        }
    }
});

window.onblur = function () {
    if (treeViewRef.value) treeViewInstance.value?.option('focusedElement', '');
};
const emptyFilterResult = () => {
    emit('emptyFilterResult', {});
};
const filterResult = ds => {
    const isFind = ds.find(item => item.dep_id === formData.depId);
    if (isFind) {
        emit('setDepart', { depId: formData.depId });
    } else {
        emit('emptyFilterResult', []);
    }
};
const onItemClick = event => {
    const currentLogin = getCookie('login');
    formData.depId = event.itemData.dep_id;
    selectedDeps.value.set(currentLogin, formData.depId);
    setCookie('selectedDep', JSON.stringify(Array.from(selectedDeps.value.entries())));
    emit('setDepart', { depId: formData.depId });
};

const meta = {
    searchHint: null,
    keyExpr: 'dep_id',
    displayExpr: 'name',
    parentIdExpr: 'parent_id',
    dataStructure: 'plain',
    rootValue: null,
    selectByClick: true,
    selectionMode: 'single',
    expandEvent: 'dbclick',
    itemTemplate: 'item',
    valueChangeEvent: 'keyup',
    animationEnabled: false,
    expandAll: true,
};

defineExpose({
    treeViewInstance,
    data,
});
</script>
<style>
.ai-app-depart-tree-item {
    display: flex;
}
.ai-department-tree-view {
    .dx-item.dx-treeview-item {
        border-width: 4px;
        border-style: solid;
        border-radius: 8px !important;
        border-color: #f6fafe;
        background-color: #fff;
        color: #000;
        fill: #286eb6;
    }
}
.ai-department-tree-view {
    .dx-state-selected {
        .dx-item.dx-treeview-item {
            border-width: 4px;
            border-style: solid;
            border-radius: 8px !important;
            border-color: #f6fafe;
            background-color: #286eb6;
            color: #fff;
            fill: #fff;
        }

        .dx-treeview-node-container {
            border-width: 0;
            border-style: none;
            border-radius: 0 !important;
            border-color: #fff;
            background-color: #fff;
            color: #000;

            .dx-item.dx-treeview-item {
                border-width: 4px;
                border-style: solid;
                border-radius: 8px !important;
                border-color: #f6fafe;
                background-color: #fff;
                color: #000;
                fill: #286eb6;
            }
        }
    }
}
.ai-app-depart-tree-item-text {
    padding-left: 10px;
    font-family: Golos, GolosText, sans-serif;
}
.ai-department-tree-view {
    height: 100%;
    overflow: hidden;
    padding-top: 20px;
    .bottom-tree-view-container {
        .dx-searchbox {
            border-radius: 4px;
            margin-bottom: 5px;
        }
    }
}
#ai-ai-app-depart-tree {
    padding-bottom: 50px;
}
#ai-app-depart-list-text {
    font-size: 24px;
    font-family: Golos, GolosText, sans-serif;
}
</style>
